import { DefaultError } from "."

interface IErrorContext {
  throwError: (error: DefaultError | null) => void
}

export const ErrorContext = React.createContext<IErrorContext | undefined>(
  undefined
)
